/*
  G W Pack gift picker: Lou's parcel (from her GIFT 3 artwork) in the spin window.
  28 Sep: Lou chose ONE static black parcel. With one image there is no shuffle: it sits in the window
  and simply fades away as the product photos spin. (Give it more images to bring the shuffle back.)
  Images (Content > Files), set in sections/gift-wrap.liquid. If they can't load, nothing shows and the
  Spin window image is used instead.
  Works alongside the picker's own script in sections/gift-picker.liquid without changing it.
*/
(function(){
  if (window.GWGiftWrap) { window.GWGiftWrap.scan(); return; }
  var cfg = window.GWGiftWrapConfig || {};
  var srcs = (cfg.srcs || []).filter(Boolean);
  if (srcs.length < 1) { window.GWGiftWrap = { scan: function(){} }; return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP = cfg.stepMs || 140, MIN = cfg.minMs || 1100;

  var warmed = false;
  function warm(){ if (warmed) return; warmed = true; srcs.forEach(function(s){ var i = new Image(); i.src = s; }); }

  function setup(root){
    if (root._gwwrap) return;
    root._gwwrap = true;
    var reel = root.querySelector('[data-gwgp-reel]');
    var form = root.querySelector('[data-gwgp-form]');
    var spinBtn = root.querySelector('[data-gwgp-spin]');
    var again = root.querySelector('[data-gwgp-again]');
    var empty = root.querySelector('[data-gwgp-empty]');
    if (!reel || !form) return;

    var box = document.createElement('div');
    box.className = 'gwgp__parcel is-loading';
    var img = document.createElement('img');
    img.alt = ''; img.decoding = 'async'; img.draggable = false;
    box.appendChild(img);
    reel.appendChild(box);
    img.onload = function(){ box.classList.remove('is-loading'); };
    img.onerror = function(){ if (box.parentNode) box.parentNode.removeChild(box); };
    img.src = srcs[0];
    if (root.closest('dialog')) root.addEventListener('gwgp:open', warm); else warm();

    var busy = false, timer = null, shuffle = null, idx = 0, t0 = 0, hideTimer = null;

    function show(i){
      idx = i % srcs.length;
      img.src = srcs[idx];
      box.classList.remove('is-pop'); void box.offsetWidth; box.classList.add('is-pop');
    }
    function stopShuffle(){ clearInterval(shuffle); shuffle = null; }
    function isReady(){ var fd = new FormData(form); return !!(fd.get('who') && fd.get('occasion') && fd.get('budget')); }
    function start(){
      if (busy || !box.parentNode || !isReady()) return;
      busy = true; t0 = Date.now();
      clearTimeout(hideTimer);
      box.classList.remove('is-gone');
      if (!reduce && srcs.length > 1){ stopShuffle(); show(idx + 1); shuffle = setInterval(function(){ show(idx + 1); }, STEP); }
      clearTimeout(timer); timer = setTimeout(reset, 15000);
    }
    function reveal(){
      var wait = (reduce || srcs.length < 2) ? 0 : Math.max(0, MIN - (Date.now() - t0));
      hideTimer = setTimeout(function(){ stopShuffle(); box.classList.add('is-gone'); }, wait);
    }
    function reset(){ busy = false; stopShuffle(); clearTimeout(timer); clearTimeout(hideTimer); box.classList.remove('is-gone'); if (srcs.length > 1) show(0); }

    form.addEventListener('submit', function(){ if (spinBtn && !spinBtn.disabled) start(); }, true);
    if (again) again.addEventListener('click', function(){ if (!again.disabled) start(); }, true);

    new MutationObserver(function(){
      var c = reel.classList;
      if (busy && c.contains('is-moving') && !box.classList.contains('is-gone')) reveal();
      if (busy && c.contains('is-landed')){ busy = false; clearTimeout(timer); if (!box.classList.contains('is-gone')) reveal(); }
    }).observe(reel, { attributes: true, attributeFilter: ['class'] });

    if (empty) new MutationObserver(function(){ if (empty.style.display === 'block') reset(); })
      .observe(empty, { attributes: true, attributeFilter: ['style'] });
  }

  function scan(){ [].forEach.call(document.querySelectorAll('[data-gwgp]'), setup); }
  window.GWGiftWrap = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
